// extracted by mini-css-extract-plugin
export default {"addCustomFood":"AddCustomFoodButton_addCustomFood__6eVCW","addCustomFoodButton":"AddCustomFoodButton_addCustomFoodButton__xMisG"};